export const convertBytes = (value: number): string => {
  const kilobyte = 1024
  const megabyte = kilobyte * 1024

  const bytes = Math.abs(value)
  if (bytes < kilobyte) {
    const result = bytes + ' B'
    return (value < 0) ? `-${result}` : result
  } else if (bytes < megabyte) {
    const result = (bytes / kilobyte).toFixed(2) + ' kb'
    return (value < 0) ? `-${result}` : result
  } else {
    const result = (bytes / megabyte).toFixed(2) + ' mb'
    return (value < 0) ? `-${result}` : result
  }
}

